import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { Icon as n } from "@blueprintjs/core";
import { IconNames as e } from "@blueprintjs/icons";
import I from "classnames";
import "./main.scss";
const s = {
  ERROR: "ERROR",
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  TIP: "TIP"
}, c = {
  [s.ERROR]: e.ERROR,
  [s.INFO]: e.INFO_SIGN,
  [s.SUCCESS]: e.TICK,
  [s.WARNING]: e.WARNING_SIGN,
  [s.TIP]: e.LIGHTBULB
}, N = ({
  label: _,
  title: a = void 0,
  intent: o,
  wrapText: m = !1
}) => /* @__PURE__ */ d(
  "div",
  {
    className: `sds_message-box border__radius--rounded padding__around--small sds_message-box__background--${o.toLowerCase()}`,
    children: [
      /* @__PURE__ */ r(
        n,
        {
          icon: c[o],
          size: 16,
          className: `padding__right--small sds_message-box__icon sds_message-box__icon--${o.toLowerCase()}`
        }
      ),
      /* @__PURE__ */ d(
        "div",
        {
          className: I("sds_message-box__label", {
            "sds_message-box__label--truncate": !m
          }),
          children: [
            a && /* @__PURE__ */ r("div", { className: "font-bold--uppercase", children: a }),
            _
          ]
        }
      )
    ]
  }
);
N.Intent = s;
export {
  N as InlineMessage
};
//# sourceMappingURL=index.js.map
